export default {
      id: "icon-arrow-long-right-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-arrow-long-right",
      toString: function () {
        return this.url;
      }
    }